import { createFileRoute } from "@tanstack/react-router";

import Preview from "../pages/chatbot-preview";
import { RequireAuth } from "../utils/RequireAuth";

// Renders outside the _shell layout (no sidebar/navbar chrome), matching the
// App.jsx route that sat outside AppLayout. The trailing underscore in the
// filename keeps it from nesting under any future /chatbot layout route.
export const Route = createFileRoute("/chatbot_/preview")({
  component: PreviewRoute,
});

function PreviewRoute() {
  return (
    <RequireAuth require="chatbotAccess" page="chatbot">
      <Preview />
    </RequireAuth>
  );
}
